const initState = {
    projects: [
        {id:'1',title:'My name is Deeven',content:'What the life'},
        {id:'2',title:'What is your name',content:'My name is Deeven'},
        {id:'3',title:'with great power comes',content:'great responsibilities'}
    ]
}


const Projectreducer = (state = initState, action) => {
    switch(action.type){
        case 'CREATE_PROJECT':
          console.log('Created project', action.project);
          return state;
        
        case 'CREATE_PROJECT_ERROR':
        console.log('create project error', action.err);
        return state;
        
        default:
        return state;
    }
}


export default Projectreducer;